var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBabyYodaYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFF00",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35.923,20.042 c1.564,1.488,3.017,4.127,4.022,6.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M36.79,33.414 c0.498,0.949,1.644,2.544,3.439,1.701c1.856-0.872,0.938-3.046,0.356-4.09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M35.507,27.944l5.11-1.914 c0.574-0.215,1.213,0.076,1.428,0.65l0.859,2.292c0.215,0.574-0.076,1.213-0.65,1.428l-5.671,2.125"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14.077,20.042 c-1.564,1.488-3.017,4.127-4.022,6.24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.21,33.414 c-0.498,0.949-1.644,2.544-3.439,1.701c-1.856-0.872-0.938-3.046-0.356-4.09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14.493,27.944l-5.11-1.914 c-0.574-0.215-1.213,0.076-1.428,0.65l-0.859,2.292c-0.215,0.574,0.076,1.213,0.65,1.428l5.671,2.125"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M34.327,22.917l4.426,18.854 c0.147,1.126-0.532,2.199-1.618,2.53C34.867,44.991,29.602,46,25,46s-9.867-1.009-12.134-1.7c-1.086-0.331-1.765-1.404-1.618-2.53 l4.426-18.854"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M32.689,9.096 C33.54,8.324,34.795,8,36,8h11c0,0-6,7-13,7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.311,9.096 C16.46,8.324,15.205,8,14,8H3c0,0,6,7,13,7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16.374,15.437 c-0.525-0.853-0.829-1.839-0.829-2.937v0C15.545,8.511,18.697,6,25,6s9.455,2.511,9.455,6.5v0c0,1.097-0.303,2.083-0.827,2.935"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,15c0,0.552-0.448,1-1,1s-1-0.448-1-1H26z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M36,21c0,3.3-11,3.5-11,3.5S14,24.3,14,21 c0-2.33,0.11-6.55,1.83-5.83C17.64,15.92,19.17,18,25,18s7.36-2.08,9.17-2.83C35.89,14.45,36,18.67,36,21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.667,45.927V25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.333,25v20.927"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFF00",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M27.804,17.922c0,0-0.47,6.801-5.137,6.439"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13.84c0-3.56-4.746-3.56-5.933-1.187C18.067,13.84,21.627,16.213,24,13.84z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13.84c0-3.56,4.746-3.56,5.933-1.187C31.933,13.84,28.373,16.213,26,13.84z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyYodaYellow);
export default __webpack_public_path__ + "static/media/baby-yoda-yellow.fad565e6d277365eb27f6f7cf8e54f92.svg";
export { ForwardRef as ReactComponent };